import type { TargetingProviderConfig } from '@openx/types/targeting/targetingProviderConfig.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery.ts';

export const usePmpSizesFetch: TargetingProviderConfig['usePmpSizesFetch'] = () => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.content.adunit_size',
    },
  });

  const list = useMemo(() => {
    if (!optionsByPath) {
      return [];
    }

    return optionsByPath.map(option =>
      option
        ? {
            id: option.id,
            name: option.name,
            ...option.extra,
          }
        : []
    );
  }, [optionsByPath]);

  const mapById = useMemo(() => {
    return list
      .map(option => ({ [option.id]: option }))
      .reduce((acc, curr) => {
        return Object.assign(acc, curr);
      }, {});
  }, [list]);

  return {
    isSizesLoading: loading,
    sizes: mapById,
  };
};
